import {
  Input,
  Grid,
  Select,
  FormControl,
  FormLabel,
  Box,
  Tbody,
  Table,
  Checkbox,
  Flex,
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Text,
  Divider,
  Center,
  Button,
} from "@chakra-ui/react";
import CustomInput from "components/common/customInput/CustomInput";
import { FaMinusCircle, FaPlusCircle } from "react-icons/fa";
import { IoIosCloseCircle } from "react-icons/io";
import { imageToBase64 } from "utils/functions/function";

const DesignElements = [
  { label: "Form Control", value: "formControl" },
  { label: "Label", value: "label" },
  { label: "Component", value: "component" },
];

const headingOptions = [
  { label: "h1", value: "h1" },
  { label: "h2", value: "h2" },
  { label: "h3", value: "h3" },
  { label: "h4", value: "h4" },
  { label: "h5", value: "h5" },
  { label: "h6", value: "h6" },
];

const InputOptions = [
  { label: "Text", value: "text" },
  { label: "Telephone", value: "tel" },
  { label: "Color", value: "color" },
  { label: "URL", value: "url" },
  { label: "Password", value: "password" },
];

const NumberOptions = [
  { label: "Number", value: "number" },
  { label: "Range", value: "range" },
];

const DateOptions = [
  { label: "Date", value: "date" },
  { label: "Time", value: "time" },
  { label: "DateTime-Local", value: "datetime-local" },
];

const ButtonOptions = [
  // {label: "Button", value: "button"},
  { label: "Submit", value: "submit" },
  { label: "Reset", value: "reset" },
];

const borderStyles = [
  { label: "None", value: "none" },
  { label: "Solid", value: "solid" },
  { label: "Dashed", value: "dashed" },
  { label: "Dotted", value: "dotted" },
  { label: "Double", value: "double" },
];

const textTransform = [
  { label: "Upper Case", value: "uppercase" },
  { label: "Lower Case", value: "lowercase" },
  { label: "Capitalize", value: "capitalize" },
];

const textDecoration = [
  { label: "Over Line", value: "overline" },
  { label: "Under Line", value: "underline" },
  { label: "Line Through", value: "line-through" },
];

type settingsProps = {
  type: any;
  id: any;
  elementValue: any;
  setElementValue: React.Dispatch<React.SetStateAction<any>>;
  handleLabelChange: any;
};

const ElementSettings = ({
  type,
  id,
  elementValue,
  setElementValue,
  handleLabelChange,
}: settingsProps) => {
  console.log("elementValue", elementValue);

  const handleSelectChange = (e: any) => {
    const selectedValue = e.target.value;
    updateElementValue("subType", selectedValue);
  };

  const updateElementValue = (name: any, value: any) => {
    setElementValue((prevValue: any) => ({
      ...prevValue,
      [name]: value,
    }));
  };

  const handleOptionChange = (index: number, key: string, value: any) => {
    console.log("val", value);
    const newOptions = [...elementValue.option];
    newOptions[index] = { ...newOptions[index], [key]: value };
    updateElementValue("option", newOptions);
  };

  const handleAttributeChange = (index: number, key: string, value: any) => {
    console.log("val", value);
    const newOptions = [...elementValue.customAttributes];
    newOptions[index] = { ...newOptions[index], [key]: value };
    updateElementValue("customAttributes", newOptions);
  };

  const addOption = (index: number) => {
    const newOptions = [
      ...elementValue.option.slice(0, index + 1),
      { label: "", value: "", selected: false },
      ...elementValue.option.slice(index + 1),
    ];
    updateElementValue("option", newOptions);
  };

  const deleteOption = (index: number) => {
    if (elementValue?.option.length > 1) {
      const newOptions = elementValue?.option.filter(
        (_: any, i: any) => i !== index
      );
      updateElementValue("option", newOptions);
    }
  };

  const addAttributes = (index: number) => {
    const newOptions = [
      ...elementValue.customAttributes.slice(0, index + 1),
      { attribute: "", value: "", selected: false },
      ...elementValue.customAttributes.slice(index + 1),
    ];
    updateElementValue("customAttributes", newOptions);
  };

  const deleteAttributes = (index: number) => {
    if (elementValue?.customAttributes.length > 1) {
      const newOptions = elementValue.customAttributes.filter(
        (_: any, i: any) => i !== index
      );
      updateElementValue("customAttributes", newOptions);
    }
  };

  const handleFileChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    name: string
  ) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      const filePromises = Array.from(files).map((file) =>
        imageToBase64(file).then((base64String: string) => ({
          name: file.name,
          file: base64String,
        }))
      );

      Promise.all(filePromises)
        .then((base64Files) => {
          setElementValue({
            ...elementValue,
            [name]: base64Files,
          });
        })
        .catch((error: any) => {
          console.error("Error converting images to base64:", error);
        });
    }
  };

  // for design element
  const handleChange = (field: string, element: any, name: any, value: any) => {
    console.log(field, element, name, value);
    setElementValue((prevState: any) => {
      const updatedElement = {
        ...prevState[field]?.[element],
        [name]: value,
      };
      if (!prevState[field]) {
        prevState[field] = {};
      }
      prevState[field][element] = updatedElement;

      return { ...prevState };
    });
  };

  // to delete color setting field to reset values
  const handleFieldDelete = (field: string, element: string, name: string) => {
    setElementValue((prevState: any) => {
      // Create a copy of the current state for the specified field and element
      const updatedField = { ...prevState[field] };
      const updatedElement = { ...updatedField[element] };

      // Delete the name from the element
      delete updatedElement[name];

      // Update the field with the modified element
      updatedField[element] = updatedElement;

      return {
        ...prevState,
        [field]: updatedField,
      };
    });

    // To change the color of input field and setting it to default black color
    const input = document.querySelector(
      `input[name=${name}]`
    ) as HTMLInputElement;
    if (input) {
      input.value = "#000000";
    }
  };

  const handleDeleteElement = (field: string, elementKey: any) => {
    setElementValue((prevState: any) => {
      const updatedField = { ...prevState[field] };
      delete updatedField[elementKey];

      return {
        ...prevState,
        [field]: updatedField,
      };
    });
  };

  const renderInput = () => {
    switch (type) {
      case "heading":
        return (
          <>
            <CustomInput
              name={elementValue?.name}
              label="Text"
              onChange={(e: any) => {
                updateElementValue("label", e.target.value);
                // handleLabelChange(e);
              }}
              floating={true}
            />
            <FormControl variant="floating">
              <Select
                onChange={handleSelectChange}
                value={elementValue?.subType}
              >
                {headingOptions?.map((heading) => (
                  <option value={heading.value}>{heading.label}</option>
                ))}
              </Select>
              <FormLabel fontSize="sm" textTransform="capitalize">
                Type
              </FormLabel>
            </FormControl>

            {/* <CustomInput type="select" label="Type" name={elementValue?.name} options={headingOptions} /> */}
          </>
        );
      case "paragraph":
        return (
          <>
            <CustomInput
              type="textarea"
              name={elementValue?.name}
              label="Text"
              value={elementValue?.label}
              onChange={(e: any) => {
                updateElementValue("label", e.target.value);
                // handleLabelChange(e);
              }}
            />
          </>
        );
      case "textarea":
        return (
          <CustomInput
            type="number"
            name={elementValue?.name}
            label="Define Rows"
            value={elementValue?.rows}
            onChange={(e: any) => {
              updateElementValue("rows", e.target.value);
              // handleLabelChange(e);
            }}
          />
        );

      case "text":
      case "email":
      case "number":
        return (
          <>
            <CustomInput
              name={elementValue?.name}
              label="Placeholder"
              value={elementValue?.placeholder || ""}
              onChange={(e: any) =>
                updateElementValue("placeholder", e.target.value)
              }
              floating={true}
            />
            <CustomInput
              name={elementValue?.name}
              label="Predefined Value"
              value={elementValue?.value || ""}
              onChange={(e: any) => updateElementValue("value", e.target.value)}
              floating={true}
            />
            {type === "text" && (
              <FormControl variant="floating">
                <Select
                  name={elementValue?.name}
                  placeholder="Select Type"
                  onChange={(e: any) =>
                    updateElementValue("subType", e.target.value)
                  }
                  value={elementValue?.subType}
                >
                  {InputOptions?.map((option) => (
                    <option value={option.value}>{option.label}</option>
                  ))}
                </Select>
                <FormLabel fontSize="sm" textTransform="capitalize">
                  Type
                </FormLabel>
              </FormControl>
            )}
            {type === "number" && (
              <FormControl variant="floating">
                <Select
                  name={elementValue?.name}
                  placeholder="Select Type"
                  onChange={(e: any) =>
                    updateElementValue("subType", e.target.value)
                  }
                  value={elementValue?.subType}
                >
                  {NumberOptions.map((option) => (
                    <option value={option.value}>{option.label}</option>
                  ))}
                </Select>
                <FormLabel fontSize="sm" textTransform="capitalize">
                  Type
                </FormLabel>
              </FormControl>
            )}
            <CustomInput
              name={elementValue?.name}
              type="number"
              label="Min Length"
              value={elementValue?.min || ""}
              onChange={(e: any) => updateElementValue("min", e.target.value)}
              floating={true}
            />
            <CustomInput
              type="number"
              name={elementValue?.name}
              label="Max Length"
              value={elementValue?.max || ""}
              onChange={(e: any) => updateElementValue("max", e.target.value)}
              floating={true}
            />
            {type === "number" && (
              <CustomInput
                name={elementValue?.name}
                type="number"
                label="Step length"
                value={elementValue?.step || ""}
                onChange={(e: any) =>
                  updateElementValue("step", e.target.value)
                }
                floating={true}
              />
            )}
          </>
        );
      case "date":
        return (
          <>
            <FormControl variant="floating">
              <Select
                name={elementValue?.name}
                placeholder="Select Type"
                onChange={(e: any) =>
                  updateElementValue("subType", e.target.value)
                }
                value={elementValue?.subType}
              >
                {DateOptions?.map((option) => (
                  <option value={option.value}>{option.label}</option>
                ))}
              </Select>
              <FormLabel fontSize="sm" textTransform="capitalize">
                Type
              </FormLabel>
            </FormControl>
            <CustomInput
              name={elementValue?.name}
              label="Min Date"
              value={elementValue?.min || ""}
              onChange={(e: any) => updateElementValue("min", e.target.value)}
              floating={true}
            />
            <Text fontSize="12px" color="blue.500" mt="-1rem">
              Please use YYYY-MM-DD format
            </Text>
            <CustomInput
              name={elementValue?.name}
              label="Max Date"
              value={elementValue?.max || ""}
              onChange={(e: any) => updateElementValue("max", e.target.value)}
              floating={true}
            />
            <Text fontSize="12px" color="blue.500" mt="-1rem">
              Please use YYYY-MM-DD format
            </Text>
            <CustomInput
              name={elementValue?.name}
              label="Step length"
              value={elementValue?.step || ""}
              onChange={(e: any) => updateElementValue("step", e.target.value)}
              floating={true}
            />
          </>
        );
      case "select":
      case "radio":
      case "checkbox":
        return (
          <Box>
            <FormLabel fontSize="sm">Options</FormLabel>
            <Box border="2px solid #e2e8f0" p={2} alignItems="center">
              {elementValue?.option.map((option: any, index: any) => (
                <Flex key={index} alignItems="center" gap={2} mt={2} m={1}>
                  <Checkbox
                    isChecked={option?.selected}
                    onChange={(e) =>
                      handleOptionChange(index, "selected", e.target.checked)
                    }
                  />

                  <Input
                    placeholder="Label"
                    value={option?.label}
                    onChange={(e) =>
                      handleOptionChange(index, "label", e.target.value)
                    }
                  />

                  <Input
                    placeholder="Value"
                    value={option?.value}
                    onChange={(e) =>
                      handleOptionChange(index, "value", e.target.value)
                    }
                  />

                  <Flex gap={1}>
                    <FaPlusCircle
                      fontSize="xs"
                      color="green"
                      onClick={() => addOption(index)}
                      cursor="pointer"
                    />
                    <FaMinusCircle
                      fontSize="xs"
                      color="#C53030"
                      onClick={() => deleteOption(index)}
                      cursor="pointer"
                    />
                  </Flex>
                </Flex>
              ))}
            </Box>
          </Box>
        );
      case "file":
        return (
          <>
            <CustomInput
              name={elementValue?.name}
              label="Accept Type"
              onChange={(e: any) =>
                updateElementValue("acceptType", e.target.value)
              }
              floating={true}
              value={elementValue?.acceptType || ""}
            />
            <CustomInput
              name={elementValue?.name}
              label="Min Files"
              onChange={(e: any) =>
                updateElementValue("minFiles", e.target.value)
              }
              floating={true}
              value={elementValue?.minFiles || ""}
            />
            <CustomInput
              name={elementValue?.name}
              label="Max Files"
              onChange={(e: any) =>
                updateElementValue("maxFiles", e.target.value)
              }
              floating={true}
              value={elementValue?.maxFiles || ""}
            />
            <CustomInput
              name={elementValue?.name}
              label="Min File Size"
              onChange={(e: any) =>
                updateElementValue("minSize", e.target.value)
              }
              floating={true}
              value={elementValue?.minSize || ""}
            />
            <CustomInput
              name={elementValue?.name}
              label="Max File Size"
              onChange={(e: any) =>
                updateElementValue("maxSize", e.target.value)
              }
              floating={true}
              value={elementValue?.maxSize || ""}
            />
          </>
        );
      case "button":
        return (
          <FormControl variant="floating">
            <Select
              name={elementValue?.name}
              placeholder="Select Type"
              onChange={(e: any) =>
                updateElementValue("subType", e.target.value)
              }
              value={elementValue?.subType}
            >
              {ButtonOptions?.map((option) => (
                <option value={option.value}>{option.label}</option>
              ))}
            </Select>
            <FormLabel fontSize="sm" textTransform="capitalize">
              Type
            </FormLabel>
          </FormControl>
        );
      case "logo":
        return (
          <>
            <CustomInput
              value={elementValue?.name}
              onChange={(e: any) => updateElementValue("name", e.target.value)}
              //   placeholder="Add Name"
              name={elementValue?.name}
              label="Name"
              floating={true}
            />
            <FormControl>
              <FormLabel fontSize="sm">Upload Logo:</FormLabel>
              <CustomInput
                type="file"
                name={elementValue?.name}
                onChange={(e: any) => handleFileChange(e, "logo")}
              />
            </FormControl>
            {elementValue?.logo && (
              <Text textDecoration={"underline"} color="blue.400" fontSize="xs" mt="-1rem">
                {elementValue?.logo[0]?.name}
              </Text>
            )}
            <CustomInput
              name={elementValue?.name}
              label="Box Size"
              onChange={(e: any) =>
                updateElementValue("boxSize", e.target.value)
              }
              floating={true}
              value={elementValue?.boxSize || ""}
            />
          </>
        );
    }
  };
  console.log("type", elementValue);

  const renderCheckbox = (
    type: string,
    updateElementValue: (key: string, value: any) => void
  ) => {
    const commonCheckboxes = (
      <>
        <Checkbox
          onChange={(e: any) =>
            updateElementValue("required", e.target.checked)
          }
          fontSize="sm"
          isChecked={elementValue?.required}
        >
          Required <span style={{ color: "red" }}>*</span>
        </Checkbox>
        <Checkbox
          onChange={(e: any) =>
            updateElementValue("disabled", e.target.checked)
          }
          fontSize="sm"
          isChecked={elementValue?.disabled}
        >
          Disabled
        </Checkbox>
      </>
    );

    let additionalCheckbox = null;
    switch (type) {
      case "text":
      case "email":
      case "number":
        additionalCheckbox = (
          <>
            <Checkbox
              onChange={(e: any) =>
                updateElementValue("readOnly", e.target.checked)
              }
              fontSize="sm"
              isChecked={elementValue?.readOnly}
            >
              Read Only
            </Checkbox>
            <Checkbox
              onChange={(e: any) =>
                updateElementValue("unique", e.target.checked)
              }
              fontSize="sm"
              isChecked={elementValue?.unique}
            >
              Unique
            </Checkbox>
          </>
        );
        break;
      case "radio":
      case "checkbox":
        additionalCheckbox = (
          <>
            <Checkbox
              onChange={(e: any) =>
                updateElementValue("inline", e.target.checked)
              }
              fontSize="sm"
              isChecked={elementValue?.inline}
            >
              Inline
            </Checkbox>
            <Checkbox
              onChange={(e: any) =>
                updateElementValue("allowMultiple", e.target.checked)
              }
              fontSize="sm"
              isChecked={elementValue?.allowMultiple}
            >
              Allow Multiple
            </Checkbox>
          </>
        );
        break;
      case "select":
        additionalCheckbox = (
          <>
            <Checkbox
              onChange={(e: any) =>
                updateElementValue("allowMultiple", e.target.checked)
              }
              fontSize="sm"
            >
              Allow Multiple
            </Checkbox>
          </>
        );
        break;
      case "file":
        additionalCheckbox = (
          <Checkbox
            onChange={(e: any) =>
              updateElementValue("allowMultiple", e.target.checked)
            }
            fontSize="sm"
          >
            Allow Multiple
          </Checkbox>
        );
        break;
      default:
        break;
    }

    return (
      <>
        {type !== "logo" && commonCheckboxes}
        {additionalCheckbox}
      </>
    );
  };

  // for excluding label and formcontrol for type heading and button

  const filteredElements = DesignElements.filter((element) => {
    if (type === "heading" || type === "button") {
      return element.value === "component";
    }
    return true;
  });

  console.log("filtered element", filteredElements);
  return (
    <>
      <Grid gap={4}>
        {type !== "heading" &&
          type !== "paragraph" &&
          type !== "spacer" &&
          type !== "divider" &&
          type !== "logo" && (
            <>
              <CustomInput
                value={elementValue?.name}
                onChange={(e: any) =>
                  updateElementValue("name", e.target.value)
                }
                //   placeholder="Add Name"
                name={elementValue?.name}
                label="Name"
                floating={true}
              />
              <CustomInput
                value={elementValue?.label}
                onChange={(e: any) => {
                  updateElementValue("label", e.target.value);
                  // handleLabelChange(e);
                }}
                //   placeholder="Add Label"
                name={elementValue?.name}
                label="Label"
                floating={true}
              />
              <CustomInput
                value={elementValue?.description || ""}
                onChange={(e: any) =>
                  updateElementValue("description", e.target.value)
                }
                //   placeholder="Add Helper Text"
                name={elementValue?.name}
                label="Helper Text"
                floating={true}
              />
              <FormControl variant="floating">
                <Select
                  name={elementValue?.name}
                  placeholder="Select placement"
                  onChange={(e: any) =>
                    updateElementValue("descriptionPlacement", e.target.value)
                  }
                  value={elementValue?.descriptionPlacement}
                >
                  <option value="below">Below</option>
                  <option value="above">Above</option>
                </Select>
                <FormLabel fontSize="sm" textTransform="capitalize">
                  Helper Text Placement
                </FormLabel>
              </FormControl>
            </>
          )}

        {renderInput()}
        <CustomInput
          value={elementValue?.className || ""}
          onChange={(e: any) => updateElementValue("className", e.target.value)}
          //   placeholder="Add Helper Text"
          name={elementValue?.name}
          label="CSS Class"
          floating={true}
        />
      </Grid>
      <Grid gap={2}>
        <FormLabel fontSize="sm" textTransform="capitalize" mt={2}>
          Custom Attributes
        </FormLabel>
        <Box border="2px solid #e2e8f0" p={2} alignItems="center">
          {elementValue?.customAttributes.map((option: any, index: any) => (
            <Flex key={index} alignItems="center" gap={2} m={1}>
              <Checkbox
                isChecked={option?.selected}
                onChange={(e) =>
                  handleAttributeChange(index, "selected", e.target.checked)
                }
              />

              <Input
                placeholder="Attribute"
                value={option?.attribute}
                onChange={(e) =>
                  handleAttributeChange(index, "attribute", e.target.value)
                }
              />

              <Input
                placeholder="Value"
                value={option?.value}
                onChange={(e) =>
                  handleAttributeChange(index, "value", e.target.value)
                }
              />

              <Flex gap={1}>
                <FaPlusCircle
                  fontSize="xs"
                  color="green"
                  onClick={() => addAttributes(index)}
                  cursor="pointer"
                />
                <FaMinusCircle
                  fontSize="xs"
                  color="#C53030"
                  onClick={() => deleteAttributes(index)}
                  cursor="pointer"
                />
              </Flex>
            </Flex>
          ))}
        </Box>
        {type !== "spacer" && type !== "divider" && type !== "logo" && (
          <>
            <FormLabel fontSize="sm" textTransform="capitalize" mt={2}>
              Add Style
            </FormLabel>
            {filteredElements.map((element: any, index: any) => (
              <Accordion allowMultiple key={index}>
                <AccordionItem>
                  <h2>
                    <AccordionButton>
                      <Box as="span" flex="1" textAlign="left">
                        {element.label}
                      </Box>
                      <AccordionIcon />
                    </AccordionButton>
                  </h2>
                  <AccordionPanel pb={4}>
                    <Grid gap={2}>
                      <Text fontSize="xs" fontWeight="700" color="gray.400">
                        Background
                      </Text>
                      <Divider orientation="horizontal" />
                      <FormControl>
                        <FormLabel>Background Color</FormLabel>
                        <Flex
                          justifyContent="space-between"
                          alignItems="center"
                          gap={2}
                        >
                          <Input
                            type="color"
                            name="bgColor"
                            value={
                              elementValue?.style?.[element.value]?.bgColor ||
                              ""
                            }
                            onChange={(e) =>
                              handleChange(
                                "style",
                                element.value,
                                "bgColor",
                                e.target.value
                              )
                            }
                          />
                          <IoIosCloseCircle
                            fontSize="30px"
                            color="#C53030"
                            onClick={() =>
                              handleFieldDelete(
                                "style",
                                element.value,
                                "bgColor"
                              )
                            }
                            cursor="pointer"
                          />
                        </Flex>
                      </FormControl>
                      <Text fontSize="xs" fontWeight="700" color="gray.400">
                        Border
                      </Text>
                      <Divider orientation="horizontal" />
                      <Flex justifyContent="space-between" gap={2}>
                        <FormControl>
                          <FormLabel fontSize="sm" textTransform="capitalize">
                            Border Style
                          </FormLabel>
                          <Select
                            name="borderStyle"
                            value={
                              elementValue?.style?.[element.value]
                                ?.borderStyle || ""
                            }
                            onChange={(e) =>
                              handleChange(
                                "style",
                                element.value,
                                "borderStyle",
                                e.target.value
                              )
                            }
                          >
                            {borderStyles?.map((option) => (
                              <option value={option.value}>
                                {option.label}
                              </option>
                            ))}
                          </Select>
                        </FormControl>
                        <FormControl>
                          <FormLabel>Border Width</FormLabel>
                          <Input
                            name="borderWidth"
                            value={
                              elementValue?.style?.[element.value]
                                ?.borderWidth || ""
                            }
                            onChange={(e) =>
                              handleChange(
                                "style",
                                element.value,
                                "borderWidth",
                                e.target.value
                              )
                            }
                          />
                        </FormControl>
                      </Flex>
                      <FormControl>
                        <FormLabel>Border Color</FormLabel>
                        <Flex
                          justifyContent="space-between"
                          alignItems="center"
                          gap={2}
                        >
                          <Input
                            type="color"
                            name="borderColor"
                            value={
                              elementValue?.style?.[element.value]
                                ?.borderColor || ""
                            }
                            onChange={(e) =>
                              handleChange(
                                "style",
                                element.value,
                                "borderColor",
                                e.target.value
                              )
                            }
                          />
                          <IoIosCloseCircle
                            fontSize="30px"
                            color="#C53030"
                            onClick={() =>
                              handleFieldDelete(
                                "style",
                                element.value,
                                "borderColor"
                              )
                            }
                            cursor="pointer"
                          />
                        </Flex>
                      </FormControl>
                      <Text fontSize="xs" fontWeight="700" color="gray.400">
                        Spacing
                      </Text>
                      <Divider orientation="horizontal" />
                      <Flex justifyContent="space-between" gap={2}>
                        <FormControl>
                          <FormLabel>Margin</FormLabel>
                          <Input
                            name="margin"
                            value={
                              elementValue?.style?.[element.value]?.margin || ""
                            }
                            onChange={(e) =>
                              handleChange(
                                "style",
                                element.value,
                                "margin",
                                e.target.value
                              )
                            }
                          />
                        </FormControl>
                        <FormControl>
                          <FormLabel>Padding</FormLabel>
                          <Input
                            name="padding"
                            value={
                              elementValue?.style?.[element.value]?.padding ||
                              ""
                            }
                            onChange={(e) =>
                              handleChange(
                                "style",
                                element.value,
                                "padding",
                                e.target.value
                              )
                            }
                          />
                        </FormControl>
                      </Flex>
                      <Text fontSize="xs" fontWeight="700" color="gray.400">
                        Text
                      </Text>
                      <Divider orientation="horizontal" />
                      <FormControl>
                        <FormLabel>Font Color</FormLabel>
                        <Flex
                          justifyContent="space-between"
                          alignItems="center"
                          gap={2}
                        >
                          <Input
                            type="color"
                            name="fontColor"
                            value={
                              elementValue?.style?.[element.value]?.fontColor ||
                              ""
                            }
                            onChange={(e) =>
                              handleChange(
                                "style",
                                element.value,
                                "fontColor",
                                e.target.value
                              )
                            }
                          />
                          <IoIosCloseCircle
                            fontSize="30px"
                            color="#C53030"
                            onClick={() =>
                              handleFieldDelete(
                                "style",
                                element.value,
                                "fontColor"
                              )
                            }
                            cursor="pointer"
                          />
                        </Flex>
                      </FormControl>
                      <Flex justifyContent="space-between" gap={2}>
                        <FormControl>
                          <FormLabel>Font Size</FormLabel>
                          <Input
                            name="fontSize"
                            value={
                              elementValue?.style?.[element.value]?.fontSize ||
                              ""
                            }
                            onChange={(e) =>
                              handleChange(
                                "style",
                                element.value,
                                "fontSize",
                                e.target.value
                              )
                            }
                          />
                        </FormControl>
                        <FormControl>
                          <FormLabel>Font Weight</FormLabel>
                          <Input
                            name="fontWeight"
                            value={
                              elementValue?.style?.[element.value]
                                ?.fontWeight || ""
                            }
                            onChange={(e) =>
                              handleChange(
                                "style",
                                element.value,
                                "fontWeight",
                                e.target.value
                              )
                            }
                          />
                        </FormControl>
                      </Flex>
                      <Flex justifyContent="space-between" gap={2}>
                        <FormControl>
                          <FormLabel>Text Transform</FormLabel>
                          <Select
                            name="textTransform"
                            value={
                              elementValue?.style?.[element.value]
                                ?.textTransform || ""
                            }
                            onChange={(e) =>
                              handleChange(
                                "style",
                                element.value,
                                "textTransform",
                                e.target.value
                              )
                            }
                          >
                            {textTransform?.map((option) => (
                              <option value={option.value}>
                                {option.label}
                              </option>
                            ))}
                          </Select>
                        </FormControl>
                        <FormControl>
                          <FormLabel>Text Decoration</FormLabel>
                          <Select
                            name="textDecoration"
                            value={
                              elementValue?.style?.[element.value]
                                ?.textDecoration
                            }
                            onChange={(e) =>
                              handleChange(
                                "style",
                                element.value,
                                "textDecoration",
                                e.target.value
                              )
                            }
                          >
                            {textDecoration?.map((option) => (
                              <option value={option.value}>
                                {option.label}
                              </option>
                            ))}
                          </Select>
                        </FormControl>
                      </Flex>
                      <Center>
                        <Button
                          onClick={() =>
                            handleDeleteElement("style", element?.value)
                          }
                          colorScheme="red"
                          fontSize="sm"
                        >
                          Reset
                        </Button>
                      </Center>
                    </Grid>
                  </AccordionPanel>
                </AccordionItem>
              </Accordion>
            ))}
          </>
        )}

        {renderCheckbox(type, updateElementValue)}
      </Grid>
    </>
  );
};

export default ElementSettings;
